"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.configMultilineMultibar = exports.configMultilineBar = exports.configLineBar = exports.configRangeBar = exports.multibar2 = exports.barWithRangeMultiLine = exports.barWithRange = exports.multiLineWithTransactions2 = exports.lineWithTransactions2 = exports.rangeWithTransaction = exports.configRange = exports.configLineStack = exports.configBar3 = exports.configBar2 = exports.configBar = exports.configMultiBar = exports.configStack = exports.configStack2 = exports.configLineMulti = exports.configLine = void 0;
var IMAGE_MARGIN = 20;
var CHART_LABEL_MARGIN = 140;
var CHART_MARGIN = 40;
var POINT_SIZE = 12;
var LINE_DENSITY = 3;
var FONT_SIZE = 24;
var CURSOR = 520;
var MONTHS2 = [
    'Jan\n2016', 'Feb\n2016', 'Mar\n2016',
    'Apr\n2016', 'May\n2016', 'Jun\n2016',
    'Jul\n2016', 'Aug\n2016', 'Sep\n2016',
    'Oct\n2016', 'Nov\n2016', 'Dec\n2016',
    'Jan\n2017', 'Feb\n2017', 'Mar\n2017',
    'Apr\n2017', 'May\n2017', 'Jun\n2017',
    'Jul\n2017', 'Aug\n2017', 'Sep\n2017',
    'Oct\n2017', 'Nov\n2017', 'Dec\n2017',
    'Jan\n2018', 'Feb\n2018', 'Mar\n2018',
    'Apr\n2018', 'May\n2018', 'Jun\n2018',
    'Jul\n2018', 'Aug\n2018', 'Sep\n2018',
    'Oct\n2018', 'Nov\n2018', 'Dec\n2018',
    'Jan\n2019', 'Feb\n2019', 'Mar\n2019',
    'Apr\n2019'
];
var MONTHS = [
    '01\n16', '02\n16', '03\n16',
    '04\n16', '05\n16', '06\n16',
    '07\n16', '08\n16', '09\n16',
    '10\n16', '11\n16', '12\n16',
    '01\n17', '02\n17', '03\n17',
    '04\n17', '05\n17', '06\n17',
    '07\n17', '08\n17', '09\n17',
    '10\n17', '11\n17', '12\n17',
    '01\n18', '02\n18', '03\n18',
    '04\n18', '05\n18', '06\n18',
    '07\n18', '08\n18', '09\n18',
    '10\n18', '11\n18', '12\n18',
    '01\n19', '02\n19', '03\n19',
    '04\n19'
];
var PRICE_RANGES = [
    '<4M',
    '4-5M', '5-6M', '6-7M', '7-8M', '8-9M', '9-10M',
    '10-12M', '12-14M', '14-16M', '16-18M', '18-20M',
    '20-25M', '25-30M', '30-35M', '35-40M', '40-45M', '45-50M',
    '50-60M', '60-70M', '70-80M', '80-90M', '90M-100M',
    '100M+'
];
var legends = [
    {
        color: '#c33306',
        text: '<5M'
    }, {
        color: '#fba200',
        text: '5-10M'
    }, {
        color: '#d2d015',
        text: '10-15M'
    },
    {
        color: '#90c221',
        text: '15-20M'
    },
    {
        color: '#0680c3',
        text: '20-25M'
    },
    {
        color: '#c306b8',
        text: '25M+'
    }
];
var line = {
    id: 'line1',
    type: 'line',
    selectedLineColor: '#ccc',
    selectedIndex: -1,
    width: 1600,
    height: 640,
    xAxis: {
        marginStart: CHART_LABEL_MARGIN,
        marginEnd: CHART_MARGIN * 2,
        fontSize: FONT_SIZE,
        color: '#ccc',
        legendColor: '#ccc',
        label: 'Month',
        series: MONTHS.slice(0, 36),
    },
    yAxis: {
        ignoreZeroPoint: true,
        marginStart: CHART_MARGIN * 2,
        marginEnd: CHART_MARGIN * 2,
        valueSize: POINT_SIZE,
        lineDensity: LINE_DENSITY,
        color: '#085963',
        label: 'Price / sqft (gross) & Transactions',
        fontSize: FONT_SIZE,
        zeroBased: false,
        series: [],
    },
    values: [
        {
            label: 'Price1',
            color: 'green',
            size: 0,
            series: [
                0, 0, 11437,
                12005, 12022, 12791,
                13222, 12745, 12561,
                13111, 12207, 12414,
                12447, 12232, 12553,
                12243, 0, 0,
                13041, 0, 12271,
                13011, 13051, 14027,
                14202, 13897, 14010,
                14250, 15248, 15095,
                15068, 15487, 14670,
                14670, 0, 0,
            ]
        }
    ]
};
var line2ValueSeries = [
    22013, 21330, 21437,
    22005, 22022, 22791,
    23222, 22745, 22561,
    23111, 22207, 22414,
    22447, 22232, 22553,
    22243, 22574, 22486,
    23041, 23091, 22271,
    23011, 23051, 24027,
    24202, 23897, 24010,
    24250, 25248, 25095,
    25068, 25487, 24670,
    24670, 26000, 25477,
];
var line3ValueSeries = [
    17013, 16330, 16437,
    17005, 17022, 17791,
    18222, 17745, 17561,
    18111, 17207, 17414,
    17447, 17232, 17553,
    17243, 17574, 17486,
    18041, 18091, 17271,
    18011, 18051, 19027,
    19202, 18897, 19010,
    19250, 20248, 20095,
    20068, 20487, 19670,
    19670, 21000, 20477
];
var line4ValueSeries = [
    15477, 16000, 14670,
    14670, 15487, 15068,
    15095, 15248, 14250,
    14010, 13897, 14202,
    14027, 13051, 13011,
    12271, 13091, 13041,
    12486, 12574, 12243,
    12553, 12232, 12447,
    12414, 12207, 13111,
    12561, 12745, 13222,
    12791, 12022, 12005,
    11437, 11330, 12013
];
var line2Values = {
    label: 'Price2',
    color: 'red',
    size: 8,
    series: line2ValueSeries
};
var line3Values = {
    label: 'Price3',
    color: 'blue',
    size: 8,
    series: line3ValueSeries
};
var line4Values = {
    label: 'Price4',
    color: 'orange',
    size: 8,
    series: line4ValueSeries
};
var lineMulti = __assign(__assign({}, line), { id: 'lineM1', backgroundLineColor: '#ddd', backgroundLineWidth: 1, yAxis: __assign(__assign({}, line.yAxis), { label2: 'HK$ / sq.ft.' }), xAxis: __assign(__assign({}, line.xAxis), { innerPaddingStart: 30 }), values: [
        line.values[0],
        line4Values
    ] });
var range = {
    id: 'range1',
    type: 'range',
    selectedIndex: -1,
    thickness: 18,
    paddingScale: 2,
    width: 1600,
    height: 600,
    hasLine: false,
    selectedLineColor: '#ccc',
    backgroundLineColor: '#ddd',
    backgroundLineWidth: 1,
    xAxis: {
        marginStart: CHART_LABEL_MARGIN,
        marginEnd: CHART_MARGIN * 2,
        fontSize: FONT_SIZE,
        color: '#ccc',
        legendColor: '#ccc',
        label: 'Month',
        series: MONTHS.slice(0, 36),
    },
    yAxis: {
        marginStart: CHART_MARGIN * 2,
        marginEnd: CHART_MARGIN * 2,
        valueSize: POINT_SIZE,
        lineDensity: LINE_DENSITY,
        color: '#085963',
        label: 'HKD$ / sqft (sa)',
        fontSize: FONT_SIZE,
        zeroBased: true,
        series: [],
    },
    values: [
        {
            label: 'Price (HK$)',
            color: '#018190',
            color2: '#00c496',
            color3: '#018190',
            size: 0,
            series: [
                [12013, 12213], [11330, 11630], [11437, 11937],
                [12005, 12205], [12022, 12322], [12791, 13191],
                [13222, 13622], [12745, 13145], [12561, 12961],
                [13111, 13411], [12207, 12807], [12414, 12514],
                [12447, 12947], [12232, 12932], [12553, 12853],
                [12243, 12443], [12574, 12874], [12486, 12786],
                [13041, 13541], [13091, 13791], [12271, 12971],
                [13011, 13411], [13051, 13351], [14027, 14127],
                [14202, 14402], [13897, 14097], [14010, 14310],
                [14250, 14550], [15248, 15448], [15095, 15295],
                [15068, 15268], [15487, 15687], [14670, 14970],
                [14670, 15170], [16000, 16500], [15477, 15977],
            ]
        }
    ]
};
var lineWithTransactions = __assign(__assign({}, line), { id: 'lineT1', xAxis: __assign(__assign({}, line.xAxis), { hidden: true }), yAxis: __assign(__assign({}, line.yAxis), { label: 'Price / sqft (gross) & Transactions', zeroBased: true }) });
var lineWithLegends = __assign(__assign({}, lineWithTransactions), { legends: legends });
var stack = {
    id: 'stack1',
    type: 'stack',
    selectedLineColor: '#ccc',
    selectedIndex: -1,
    width: 1600,
    height: 600,
    backgroundColor: 'white',
    thickness: 12,
    xAxis: {
        marginStart: CHART_MARGIN * 2.5,
        marginEnd: CHART_MARGIN * 2,
        fontSize: FONT_SIZE,
        color: '#ccc',
        legendColor: '#ccc',
        label: 'Month',
        series: MONTHS,
    },
    yAxis: {
        marginStart: CHART_MARGIN * (FONT_SIZE * 0.065),
        marginEnd: CHART_MARGIN * (FONT_SIZE * 0.1),
        valueSize: POINT_SIZE,
        lineDensity: LINE_DENSITY,
        color: '#085963',
        label: 'No. of Transactions',
        label2: '# Trans.',
        fontSize: FONT_SIZE,
        zeroBased: true,
        series: [],
    },
    values: [
        {
            label: legends[0].text,
            color: legends[0].color,
            series: [
                8, 5, 4, 5, 1, 3, 8, 2, 3, 1,
                3, 1, 6, 6, 7, 6, 1, 5, 6, 5,
                3, 6, 5, 5, 7, 7, 7, 2, 2, 1,
                8, 4, 6, 7, 4, 7, 4, 1, 2, 9
            ]
        },
        {
            label: legends[1].text,
            color: legends[1].color,
            series: [
                5, 4, 5, 1, 3, 8, 2, 3, 1, 4,
                1, 6, 6, 7, 6, 1, 5, 6, 5, 3,
                6, 5, 5, 7, 7, 7, 2, 2, 1, 3,
                4, 6, 7, 4, 7, 4, 1, 2, 9, 8
            ]
        },
        {
            label: legends[2].text,
            color: legends[2].color,
            series: [
                4, 5, 1, 3, 8, 2, 3, 1, 4, 4,
                6, 6, 7, 6, 1, 5, 6, 5, 3, 1,
                5, 5, 7, 7, 7, 2, 2, 1, 3, 6,
                6, 7, 4, 7, 4, 1, 2, 9, 8, 4
            ]
        },
        {
            label: legends[3].text,
            color: legends[3].color,
            series: [
                8, 5, 4, 5, 1, 3, 8, 2, 3, 1,
                3, 1, 6, 6, 7, 6, 1, 5, 6, 5,
                3, 6, 5, 5, 7, 7, 7, 2, 2, 1,
                8, 4, 6, 7, 4, 7, 4, 1, 2, 9
            ]
        },
        {
            label: legends[4].text,
            color: legends[4].color,
            series: [
                5, 4, 5, 1, 3, 8, 2, 3, 1, 4,
                1, 6, 6, 7, 6, 1, 5, 6, 5, 3,
                6, 5, 5, 7, 7, 7, 2, 2, 1, 3,
                4, 6, 7, 4, 7, 4, 1, 2, 9, 8
            ]
        },
        {
            label: legends[5].text,
            color: legends[5].color,
            series: [
                4, 5, 1, 3, 8, 2, 3, 1, 4, 4,
                6, 6, 7, 6, 1, 5, 6, 5, 3, 1,
                5, 5, 7, 7, 7, 2, 2, 1, 3, 6,
                6, 7, 4, 7, 4, 1, 2, 9, 8, 4
            ]
        }
    ]
};
var stackWithLine = __assign(__assign({}, stack), { id: 'stackline1', offsetY: 0, yAxis: __assign(__assign({}, stack.yAxis), { label: '', marginStart: 0 }), legends: [] });
var bar = {
    id: 'bar1',
    type: 'bar',
    selectedLineColor: '#ccc',
    selectedIndex: -1,
    thickness: 18,
    width: 1600,
    height: 380,
    backgroundColor: 'white',
    xAxis: {
        marginStart: CHART_LABEL_MARGIN,
        marginEnd: CHART_MARGIN * 2,
        fontSize: FONT_SIZE,
        color: '#999',
        legendColor: '#ccc',
        label: '',
        series: MONTHS,
    },
    yAxis: {
        marginStart: CHART_MARGIN * 2,
        marginEnd: CHART_MARGIN * 2,
        valueSize: POINT_SIZE,
        lineDensity: LINE_DENSITY - 1,
        color: '#085963',
        label: 'No. of Transactions',
        fontSize: FONT_SIZE,
        zeroBased: true,
        series: [],
    },
    values: [
        {
            label: '< 5M',
            color: '#bc9408',
            series: [
                8, 5, 4, 5, 1, 3, 8, 2, 3, 1,
                3, 1, 6, 6, 7, 6, 1, 5, 6, 5,
                3, 6, 5, 5, 7, 7, 7, 2, 2, 1,
                8, 4, 6, 7, 4, 7, 4, 1, 2, 9
            ]
        }
    ]
};
var bar2 = __assign(__assign({}, bar), { id: 'bar2', xAxis: __assign(__assign({}, bar.xAxis), { series: MONTHS.slice(0, 36) }), values: [
        {
            label: 'All',
            label2: '# Transactions',
            color: '#bc9408',
            color2: '#e6b60d',
            series: [
                8, 5, 4,
                5, 1, 3,
                8, 2, 3,
                1, 3, 1,
                6, 6, 7,
                6, 1, 5,
                6, 5, 3,
                6, 5, 5,
                7, 7, 7,
                2, 2, 1,
                8, 4, 6,
                7, 4, 7,
            ]
        }
    ] });
var bar3 = {
    id: 'bar3',
    type: 'bar',
    selectedLineColor: '#ccc',
    selectedIndex: -1,
    thickness: 18,
    width: 1600,
    height: 600,
    backgroundColor: 'transparent',
    backgroundLineColor: '#ccc',
    backgroundLineWidth: 0.5,
    xAxis: {
        marginStart: CHART_LABEL_MARGIN,
        marginEnd: CHART_MARGIN * 2,
        fontSize: FONT_SIZE,
        color: '#999',
        legendColor: '#ccc',
        label: '',
        labelColor: '#777',
        series: PRICE_RANGES,
        vertical: true,
        innerPaddingStart: 10,
    },
    yAxis: {
        marginStart: CHART_MARGIN * 2,
        marginEnd: CHART_MARGIN * 3,
        valueSize: POINT_SIZE,
        lineDensity: LINE_DENSITY,
        color: 'transparent',
        label: 'No. of Transactions',
        label2: '# Trans.',
        labelColor: '#777',
        fontSize: FONT_SIZE,
        zeroBased: true,
        series: [],
    },
    values: [
        {
            label: '< 5M',
            color: '#bc9408',
            color2: '#e6b60d',
            series: [
                1,
                0, 12, 8, 35, 57, 32,
                50, 39, 6, 8, 5,
                1, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0,
                0
            ]
        }
    ]
};
var bar4 = __assign(__assign({}, bar3), { xAxis: __assign(__assign({}, bar3.xAxis), { labelColor: '#000' }), yAxis: __assign(__assign({}, bar3.yAxis), { lineDensity: LINE_DENSITY + 1, color: '#018190', labelColor: '#000' }) });
var barWithLine = __assign(__assign({}, bar), { id: 'barL1', offsetY: 260, height: 200, yAxis: __assign(__assign({}, bar.yAxis), { label: '', marginStart: 0 }) });
exports.configLine = {
    margin: IMAGE_MARGIN,
    charts: [line],
};
exports.configLineMulti = {
    margin: IMAGE_MARGIN,
    charts: [lineMulti],
};
exports.configStack2 = __assign(__assign({}, exports.configLine), { charts: [__assign(__assign({}, stack), { xAxis: __assign(__assign({}, stack.xAxis), { label: '' }) })] });
exports.configStack = __assign(__assign({}, exports.configStack2), { charts: [__assign(__assign({}, exports.configStack2.charts[0]), { yAxis: __assign(__assign({}, exports.configStack2.charts[0].yAxis), { color: 'transparent', labelColor: '#777' }), xAxis: __assign(__assign({}, exports.configStack2.charts[0].xAxis), { label: '', labelColor: '#777', innerPaddingStart: 10 }) })] });
exports.configMultiBar = __assign(__assign({}, exports.configStack2), { charts: [__assign(__assign({}, exports.configStack2.charts[0]), { id: 'multibar', type: 'multibar', yAxis: __assign(__assign({}, exports.configStack2.charts[0].yAxis), { labelColor: '#777' }), xAxis: __assign(__assign({}, exports.configStack2.charts[0].xAxis), { label: '', labelColor: '#777', innerPaddingStart: 10 }) })] });
exports.configBar = __assign(__assign({}, exports.configLine), { charts: [bar] });
exports.configBar2 = {
    margin: 0,
    charts: [bar3],
};
exports.configBar3 = {
    margin: 0,
    charts: [bar4],
};
exports.configLineStack = __assign(__assign({}, exports.configLine), { charts: [lineWithLegends, stackWithLine] });
exports.configRange = {
    margin: IMAGE_MARGIN,
    charts: [range]
};
exports.rangeWithTransaction = __assign(__assign({}, range), { id: 'rangeT1', height: 600, yAxis: __assign(__assign({}, range.yAxis), { marginEnd: 0, label: 'Price / sqft (gross) & Transactions', label2: 'HK$' }), xAxis: __assign(__assign({}, range.xAxis), { hidden: true }) });
exports.lineWithTransactions2 = __assign(__assign({}, exports.rangeWithTransaction), { id: 'lineT2', type: 'line', xAxis: __assign(__assign({}, exports.rangeWithTransaction.xAxis), { hidden: true }), yAxis: __assign(__assign({}, exports.rangeWithTransaction.yAxis), { ignoreZeroPoint: true, label2: 'HK$ / sq.ft.' }), values: [
        __assign(__assign({}, exports.rangeWithTransaction.values[0]), { size: 8, series: exports.rangeWithTransaction.values[0].series.map(function (it) { return (it[0] + it[1]) / 2; }) })
    ] });
exports.multiLineWithTransactions2 = __assign(__assign({}, exports.lineWithTransactions2), { backgroundLineColor: '#ccc', backgroundLineWidth: 0.5, yAxis: __assign(__assign({}, exports.lineWithTransactions2.yAxis), { marginStart: CHART_MARGIN / 2, marginEnd: CHART_MARGIN * 2, lineDensity: 4, color: '#333', label: 'Price / Sqft. ($)', labelColor: '#777', labelIsVertical: true, fixMax: 20000, fixStep: 5 }), xAxis: __assign(__assign({}, exports.lineWithTransactions2.xAxis), { label: '', marginEnd: 90, color: '#333', xLabelWidthMultiplyer: 1.4, innerPaddingStart: 10 }), values: [
        __assign(__assign({}, exports.lineWithTransactions2.values[0]), { color: '#ccc', label: 'Wan Chai', size: 0, series: JSON.parse(JSON.stringify(exports.lineWithTransactions2.values[0].series)).sort() }),
        __assign(__assign({}, exports.lineWithTransactions2.values[0]), { label: 'The Avenue', size: 0 })
    ] });
exports.barWithRange = __assign(__assign({}, bar2), { id: 'bar2R1', height: 200, offsetY: 150, yAxis: __assign(__assign({}, bar2.yAxis), { label: '', label2: '# Transactions', marginStart: 0 }) });
exports.barWithRangeMultiLine = __assign(__assign({}, bar2), { id: 'bar2R1', height: 600, backgroundColor: 'transparent', backgroundLineColor: 'transparent', backgroundLineWidth: 0.5, yAxis: __assign(__assign({}, bar2.yAxis), { label: 'No. of Transactions', label2: '# Transactions', labelIsVertical: true, marginStart: CHART_MARGIN / 2, marginEnd: CHART_MARGIN * 2, lineDensity: 4, color: '#777', labelColor: '#777', fixMaxExtend: 30, fixMax: 10, fixStep: 5 }), xAxis: __assign(__assign({}, bar2.xAxis), { marginStart: 90, marginEnd: 160, labelColor: '#777' }) });
exports.multibar2 = __assign(__assign({}, exports.barWithRangeMultiLine), { id: 'multibar2', type: 'multibar', values: [
        {
            label: 'All',
            label2: '# Tran. (Wan Chai)',
            color: '#bc9408',
            color2: '#e6b60d',
            series: [
                8, 5, 4,
                5, 1, 3,
                8, 2, 3,
                1, 3, 1,
                6, 6, 7,
                6, 1, 5,
                6, 5, 3,
                6, 5, 5,
                7, 7, 7,
                2, 2, 1,
                8, 4, 6,
                7, 4, 7,
            ]
        }, {
            label: 'All',
            label2: '# Tran. (The Avenue)',
            color: 'lime',
            color2: 'green',
            series: [
                7, 4, 7, 6, 4, 8, 1, 2, 2, 7, 7, 7, 5, 5, 6, 3, 5, 6, 5, 1, 6, 7, 6, 6, 1, 3, 1, 3, 2, 8, 3, 1, 5, 4, 5, 8
            ]
        }
    ], yAxis: __assign(__assign({}, exports.barWithRangeMultiLine.yAxis), { color: '#333', right: true }), xAxis: __assign(__assign({}, exports.barWithRangeMultiLine.xAxis), { color: '#333', marginStart: 140, marginEnd: 90, xLabelWidthMultiplyer: 1.4, innerPaddingStart: 10 }) });
exports.configRangeBar = {
    margin: 0,
    charts: [exports.rangeWithTransaction, exports.barWithRange]
};
exports.configLineBar = {
    margin: 0,
    charts: [exports.lineWithTransactions2, exports.barWithRange],
};
exports.configMultilineBar = {
    margin: 0,
    merged: true,
    charts: [exports.barWithRangeMultiLine, exports.multiLineWithTransactions2],
};
exports.configMultilineMultibar = {
    margin: 0,
    merged: true,
    charts: [exports.multibar2, exports.multiLineWithTransactions2],
};
